export default __webpack_public_path__ + "static/media/audio6_test.b9861e0b.m4a";